import { MainContainer } from '@app/components/Container/MainContainer';
import { ModalErrorUnathenthicated } from '@app/components/ModalErrorUnathenthicated/ModalErrorUnathenthicated';
import { Table } from '@app/modules/ConfirmTranslate/components/Table/Table';
import { Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { observer } from 'mobx-react';
import React, { FunctionComponent } from 'react';

interface IMainProps {}

export const Main: FunctionComponent<IMainProps> = observer<FunctionComponent<IMainProps>>(function (props) {
    return (
        <MainContainer>
            <Stack spacing={2}>
                <Typography variant={'h5'} className={'confirm__heading'}>
                    Translations confirmation window
                </Typography>
                <Table />
                <ModalErrorUnathenthicated />
            </Stack>
        </MainContainer>
    );
});
